<template>
  <div class="form-field">
    <p class="form-field__label" v-if="label || $slots.label">
      <slot name="label">{{ label }}</slot>
      <span v-if="required" class="form-field__required">*</span>
    </p>
    <div class="form-field__field">
      <slot name="default" />
    </div>
    <p class="form-field__error" v-if="error">{{ error }}</p>
    <p class="form-field__hint" v-else-if="hint">{{ hint }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    required: { type: Boolean, default: false },
    label: { type: String },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
  },
}
</script>

<style scoped lang="sass">
@import "~@src/legacy/sass/params"

.form-field
  position: relative

  &__field
    margin-top: 8px

  &__label
    font-size: 14px
    line-height: 1.3
    color: #1E253B

  &__required
    font-size: 13px

  &__error, &__hint
    position: absolute
    bottom: -15px
    font-size: 12px
    line-height: 1

  &__required, &__error
    color: $error
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/form/FormField.vue